import React from 'react';

const MobilePageHeader = ({
  title,
  subtitle,
  rightAction,
  onBack,
  showBack = false,
  variant = 'default',
}) => {
  const variantClasses = {
    default: 'bg-white dark:bg-gray-900 text-gray-900 dark:text-white',
    transparent: 'bg-transparent text-gray-900 dark:text-white',
    primary: 'bg-primary text-white',
  };

  return (
    <header
      className={`sticky top-0 z-30 ${variantClasses[variant]} transition-colors duration-250`}
      style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}
    >
      <div className="flex items-center justify-between px-4 h-14">
        <div className="flex items-center gap-3 min-w-0">
          {showBack && onBack && (
            <button
              onClick={onBack}
              className="flex items-center justify-center w-10 h-10 -ml-2 rounded-full hover:bg-black/5 dark:hover:bg-white/10 transition-colors"
              aria-label="Go back"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
          )}
          <div className="min-w-0">
            {title && (
              <h1 className="font-display text-lg font-bold leading-tight truncate">
                {title}
              </h1>
            )}
            {subtitle && (
              <p className={`text-sm truncate ${variant === 'primary' ? 'text-white/70' : 'text-gray-500 dark:text-gray-400'}`}>
                {subtitle}
              </p>
            )}
          </div>
        </div>
        {rightAction && (
          <div className="flex-shrink-0">{rightAction}</div>
        )}
      </div>
    </header>
  );
};

export default MobilePageHeader;
